import { useState, useEffect, useCallback } from 'react';
import { jwtDecode } from "jwt-decode";

function useAuth() {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loginInfo, setLoginInfo] = useState('');

  const logout = useCallback(() => {
    setIsAuthenticated(false);
    setLoginInfo('');
    // Clear token and related data
    localStorage.removeItem('jwt');
    localStorage.setItem('blockIds', JSON.stringify([1]));
    localStorage.setItem('blockInfo', JSON.stringify({ dslNo: '', surveyYear: '' }));
  }, []);

  const loginCallFromChild = useCallback((token) => {
    if (!token || token.trim() === '' || token === 'null') {
      logout();
      return;
    }
    try {
      const userInfo = jwtDecode(token);
      setIsAuthenticated(true);
      setLoginInfo({ userInfo, token });
      localStorage.setItem("jwt", token);
      localStorage.setItem("loginTime", Date.now().toString());
    } catch (error) {
      logout();
    }
  }, [logout]);

  useEffect(() => {
    const token = localStorage.getItem("jwt");
    if (token && token !== 'null' && token.trim() !== '') {
      try {
        const userInfo = jwtDecode(token);
        // Check if token is expired
        const currentTime = Date.now() / 1000;
        if (userInfo.exp && userInfo.exp < currentTime) {
          logout();
          return;
        }
        setIsAuthenticated(true);
        setLoginInfo({ userInfo, token });
      } catch (error) {
        console.error('Token validation error:', error);
        logout();
      }
    }
  }, [logout]);

  return {
    isAuthenticated,
    loginInfo,
    loginCallFromChild,
    logout,
  };
}

export default useAuth;